import type { WorkerTier } from '../../core/index.js'
import { TIER_HEX } from '../../core/index.js'
import { formatScore } from '../../core/index.js'

/**
 * The worker app's score dial, shared so an operator opening a worker's
 * detail sees the same thing the worker does rather than a second rendering
 * of the same number.
 */
interface ScoreRingProps {
  score: number
  tier: WorkerTier
  size?: 'lg' | 'sm'
}

export function ScoreRing({ score, tier, size = 'lg' }: ScoreRingProps) {
  const radius = 36
  const circumference = 2 * Math.PI * radius
  const offset = circumference * (1 - score / 100)
  const box = size === 'lg' ? 'w-24 h-24' : 'w-16 h-16'

  return (
    <div className={`relative ${box} mx-auto`}>
      <svg viewBox="0 0 90 90" className={`${box} -rotate-90`}>
        <circle cx="45" cy="45" r={radius} fill="none" stroke="rgba(12,94,116,0.1)" strokeWidth="8" />
        <circle
          cx="45"
          cy="45"
          r={radius}
          fill="none"
          stroke={TIER_HEX[tier]}
          strokeWidth="8"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      {/* The number alone: what the ring is is said by its heading wherever it is placed. */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className={`${size === 'lg' ? 'text-2xl' : 'text-lg'} font-black text-ink`}>{formatScore(score)}</div>
      </div>
    </div>
  )
}
